module.exports = __webpack_public_path__ + "static/img/avatar.d6134ddb.jpg";